import React from 'react';
import PropTypes from 'prop-types';
import './Button.css';

/**
 * Componente Button moderno seguindo a identidade visual Mexx
 * Suporta múltiplas variantes, tamanhos e estados
 */
const Button = ({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  fullWidth = false,
  startIcon = null,
  endIcon = null,
  onClick,
  type = 'button',
  className = '',
  ...props
}) => {
  const baseClass = 'mexx-btn';
  const variantClass = `mexx-btn--${variant}`;
  const sizeClass = `mexx-btn--${size}`;
  const disabledClass = disabled ? 'mexx-btn--disabled' : '';
  const loadingClass = loading ? 'mexx-btn--loading' : '';
  const fullWidthClass = fullWidth ? 'mexx-btn--full-width' : '';

  const buttonClass = [
    baseClass,
    variantClass,
    sizeClass,
    disabledClass,
    loadingClass,
    fullWidthClass,
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (disabled || loading) {
      e.preventDefault();
      return;
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      type={type}
      className={buttonClass}
      onClick={handleClick}
      disabled={disabled || loading}
      {...props}
    >
      {/* Loading Spinner */}
      {loading && (
        <span className="mexx-btn__loading-spinner">
          <svg
            className="mexx-btn__spinner"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="31.416"
              strokeDashoffset="31.416"
            />
          </svg>
        </span>
      )}

      {/* Start Icon */}
      {startIcon && !loading && (
        <span className="mexx-btn__icon mexx-btn__icon--start">
          {startIcon}
        </span>
      )}

      {/* Button Content */}
      <span className={`mexx-btn__content ${loading ? 'mexx-btn__content--loading' : ''}`}>
        {children}
      </span>

      {/* End Icon */}
      {endIcon && !loading && (
        <span className="mexx-btn__icon mexx-btn__icon--end">
          {endIcon}
        </span>
      )}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'ghost',
    'danger',
    'success',
    'warning',
    'info'
  ]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  startIcon: PropTypes.node,
  endIcon: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string
};

export default Button;